import React from "react";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";

/**
 * The 26% band — one number, full width, dark surface.
 *
 * The figure is plain text, not a count-up: it is the single most important
 * claim on the page, so it must be correct and readable on first paint with no
 * JS and no motion.
 */
export default function StatBand() {
  const { t } = useTranslation();

  return (
    <Section tone="dark" containerClassName="text-center">
      <p className="text-6xl font-bold leading-none tabular-nums text-white md:text-8xl">
        {t("landing.stat.value")}
      </p>
      <p className="mx-auto mt-6 max-w-3xl text-xl font-medium leading-snug text-white md:text-2xl">
        {t("landing.stat.headline")}
      </p>
      <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-gray-300">
        {t("landing.stat.sub")}
      </p>
    </Section>
  );
}
